import { render } from "./LoginBlackFW.vue?vue&type=template&id=9b5c58d0"
import script from "./LoginBlackFW.vue?vue&type=script&lang=js"
export * from "./LoginBlackFW.vue?vue&type=script&lang=js"

import "./LoginBlackFW.vue?vue&type=style&index=0&id=9b5c58d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__